// Bounds for a native <input type="date">.
//
// Such an input defaults to a maximum of 275760-09-13, and Chromium sizes the year
// segment from `max` — so with no bound the year accepts six digits, and a stray
// keystroke turns 2026 into 20261. The field then filters to nothing or fails to
// submit, with nothing on screen explaining why. A four-digit ceiling caps typing at
// four digits.
//
// Deliberately the whole four-digit range rather than a tighter window like 1900-2100.
// This caps DIGITS, which every date field on the site wants. Which years are actually
// legitimate differs per field — a date of birth, a date of service and a payment date
// do not share a range — so that stays a per-field decision, made on purpose. See
// EligibilityPage's date of birth, which bounds itself to 1900..today and should keep
// its own bounds rather than adopting these.
export const DATE_INPUT_MIN = '1000-01-01';
export const DATE_INPUT_MAX = '9999-12-31';
